/// <reference path="../../../setup/_references.ts" />
module onvio.clientDashboard.PhoneNumberListComponent {
    'use strict';

    export class PhoneNumberListController {
        public phoneNumbers: cs.IContactPhoneV1Dto[];

        private primaryPhoneNumber: cs.IContactPhoneV1Dto;
        private otherPhoneNumbers: cs.IContactPhoneV1Dto[];

        static $inject = [
            '$translate'
        ];
        constructor(
            private $translate: ng.translate.ITranslateService
        ) { }

        $onChanges() {
            this.setPrimaryPhone();
        }

        private formatPrimaryString(primary: string): string {
            if (!primary) {
                return '';
            }
            return `${primary} (${this.$translate.instant('Onvio.Reports.ClientDashboard.Primary')})`;
        }

        private formatPhoneNumber(phoneNumber: cs.IContactPhoneV1Dto): string {
            if (!phoneNumber) {
                return '';
            }

            if (phoneNumber.extension) {
                return phoneNumber.phoneNumber + ' ' + phoneNumber.extension;
            }

            return phoneNumber.phoneNumber;
        }

        // format and set the primary phone number
        private setPrimaryPhone() {
            this.primaryPhoneNumber = null;
            for (let i in this.phoneNumbers) {
                if (this.phoneNumbers[i].isPrimary) {
                    this.primaryPhoneNumber = this.phoneNumbers[i];
                }
            }

            this.otherPhoneNumbers = _.filter(this.phoneNumbers, (phoneNumber: cs.IContactPhoneV1Dto) => !phoneNumber.isPrimary);
        }
    }

    export class PhoneNumberListComponent implements ng.IComponentOptions {
        bindings: any = {
            phoneNumbers: '<'
        };
        controller = PhoneNumberListController;
        templateUrl = 'client-dashboard/components/client-dashboard-components/phone-number-list-component.html';
    }

    angular.module('onvio.clientDashboard.PhoneNumberListComponent', [])
            .component('phoneNumberList', new PhoneNumberListComponent());
}
